import { JobStatus } from "@/models/etc/types";

// Признак просрочки у завершённой работы бэк не отдаёт: поле Lost выставляется
// и для «в работе и просрочена», и для «завершена с опозданием», а Status после
// завершения всегда становится Completed. Поэтому для завершённых работ просрочку
// считаем сами, сравнивая CompletionDate со сроком.
export type JobDeadlineState = 'lost' | 'success' | 'neutral'

export type JobDeadlineInput = {
    Status: number
    ToDoDate?: string | Date | null
    CompletionDate?: string | Date | null
}

// Срок работник видит как дату без времени, поэтому и сравниваем по календарным
// дням: работа просрочена, если завершена хотя бы на день позже срока.
const startOfLocalDay = (date: string | Date): number => {
    const dateObj = typeof date === "string" ? new Date(date) : date
    return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()).getTime()
}

export function isCompletedLate(job: JobDeadlineInput): boolean {
    if (!job.CompletionDate || !job.ToDoDate) {
        return false
    }

    return startOfLocalDay(job.CompletionDate) > startOfLocalDay(job.ToDoDate)
}

export function getJobDeadlineState(job: JobDeadlineInput): JobDeadlineState {
    if (!job.CompletionDate) {
        return job.Status === JobStatus.Lost ? 'lost' : 'neutral'
    }

    return isCompletedLate(job) ? 'lost' : 'success'
}
